import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6359b8d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid shadow-sm py-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "group",
    class: "overflow"
  }, "Applying as an individual or business/organization")
], -1))
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "p-float-label prime_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, [
  /*#__PURE__*/_createTextVNode("First Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "p-float-label prime_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Middle Name", -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "p-float-label prime_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, [
  /*#__PURE__*/_createTextVNode("Last Name "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "p-float-label prime_input" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, [
  /*#__PURE__*/_createTextVNode("ID/Passport Number (and upload) "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "p-float-label prime_input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "p-float-label prime_input" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nationality",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Country of Origin"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "p-float-label prime_input" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "countryOfResidence",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Country of residence"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "p-float-label prime_input" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dob",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Date of Birth"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "p-float-label prime_input" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender",
  class: "overflow"
}, [
  /*#__PURE__*/_createTextVNode("Gender"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = { class: "p-float-label prime_input" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, [
  /*#__PURE__*/_createTextVNode("Username "),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_34 = { class: "col-md-6 mb-3" }
const _hoisted_35 = { class: "p-float-label prime_input mb-0" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, [
  /*#__PURE__*/_createTextVNode("Password"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("em", null, "at least 8 characters")
], -1))
const _hoisted_38 = { class: "col-md-6 mb-3" }
const _hoisted_39 = { class: "p-float-label prime_input mb-0" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirm_password" }, [
  /*#__PURE__*/_createTextVNode("Confirm Password"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("em", null, "at least 8 characters")
], -1))
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "p-float-label prime_input" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "landline" }, "Landline", -1))
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "p-float-label prime_input" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mobile" }, [
  /*#__PURE__*/_createTextVNode("Mobile"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Short description about yourself, your qualification(s), study and work background(s)"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_49 = { class: "w-100 text-muted d-flex justify-content-end mr-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "findOut" }, [
  /*#__PURE__*/_createTextVNode("How did you find out about this opportunity"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger mx-1" }, "*")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, [
  /*#__PURE__*/_createTextVNode(" Alternate contact "),
  /*#__PURE__*/_createElementVNode("small", { class: "span_color" }, "Information required in the event that we cannot contact the applicant.")
], -1))
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = { class: "p-float-label prime_input" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altFirstname" }, "First Name", -1))
const _hoisted_56 = { class: "col-md-4" }
const _hoisted_57 = { class: "p-float-label prime_input" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altMiddlename" }, "Middle Name", -1))
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = { class: "p-float-label prime_input" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altLastname" }, "Last Name", -1))
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "p-float-label prime_input" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altEmail" }, "Email", -1))
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "p-float-label prime_input" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "altMobile" }, "Mobile", -1))
const _hoisted_68 = { class: "d-flex" }
const _hoisted_69 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_BaseCheckBox = _resolveComponent("BaseCheckBox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_TermsAndConditions = _resolveComponent("TermsAndConditions")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      ref: "InviteInnovatorInd"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "firstname",
              name: "firstname",
              modelValue: _ctx.form.firstname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstname) = $event)),
              autocomplete: "firstname"
            }, null, 8, ["modelValue"]),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "middlename",
              name: "middlename",
              modelValue: _ctx.form.middlename,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.middlename) = $event)),
              autocomplete: "other-name"
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "lastname",
              name: "lastname",
              modelValue: _ctx.form.lastname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.lastname) = $event)),
              autocomplete: "lastname"
            }, null, 8, ["modelValue"]),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "passportNo",
              name: "passportNo",
              modelValue: _ctx.form.passportNo,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.passportNo) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "email",
              name: "email",
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.email) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_18
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.form.nationality,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.nationality) = $event)),
              id: "nationality",
              name: "nationality",
              suggestions: _ctx.selectedCountries,
              onComplete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchCountry($event))),
              field: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "suggestions"]),
            _hoisted_21
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, [
            _createVNode(_component_AutoComplete, {
              modelValue: _ctx.form.countryOfResidence,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.countryOfResidence) = $event)),
              id: "countryOfResidence",
              name: "countryOfResidence",
              suggestions: _ctx.selectedCountries,
              onComplete: _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchCountry($event))),
              field: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "suggestions"]),
            _hoisted_24
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, [
            _createVNode(_component_Calendar, {
              id: "dob",
              name: "dob",
              modelValue: _ctx.form.dob,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.dob) = $event)),
              class: "w-100",
              numberOfMonths: 1,
              maxDate: _ctx.maxDate
            }, null, 8, ["modelValue", "maxDate"]),
            _hoisted_27
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("span", _hoisted_29, [
            _createVNode(_component_Dropdown, {
              id: "gender",
              name: "gender",
              modelValue: _ctx.form.gender,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.gender) = $event)),
              options: _ctx.genders,
              optionLabel: "name",
              class: "w-100"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "username",
              name: "username",
              modelValue: _ctx.form.username,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.username) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_33
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, [
            _createVNode(_component_InputText, {
              type: "password",
              id: "password",
              name: "password",
              modelValue: _ctx.form.password,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.password) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_36
          ]),
          _hoisted_37
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("span", _hoisted_39, [
            _createVNode(_component_InputText, {
              type: "password",
              id: "confirm_password",
              name: "confirm_password",
              modelValue: _ctx.form.confirm_password,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.confirm_password) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_40
          ]),
          _hoisted_41
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("span", _hoisted_43, [
            _createVNode(_component_InputText, {
              type: "tel",
              id: "landline",
              name: "landline",
              modelValue: _ctx.form.landline,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.landline) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_44
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("span", _hoisted_46, [
            _createVNode(_component_InputText, {
              type: "tel",
              id: "mobile",
              name: "mobile",
              modelValue: _ctx.form.mobile,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.mobile) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_47
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_48,
        _createVNode(_component_Textarea, {
          modelValue: _ctx.form.description,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.description) = $event)),
          id: "description",
          name: "description",
          autoResize: true,
          rows: "5",
          cols: "30",
          placeholder: "Enter text here...",
          class: "w-100"
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_49, _toDisplayString(_ctx.form.description.length) + "/250", 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_50,
        _createVNode(_component_Dropdown, {
          id: "findOut",
          name: "findOut",
          modelValue: _ctx.form.findOut,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.findOut) = $event)),
          options: _ctx.findOutProp,
          optionLabel: "id",
          optionValue: "id",
          placeholder: "Select how you found out about this opportunity",
          class: "w-100 mb-3"
        }, null, 8, ["modelValue", "options"])
      ]),
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("span", _hoisted_54, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altFirstname",
              name: "altFirstname",
              modelValue: _ctx.form.altFirstname,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.altFirstname) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_55
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("span", _hoisted_57, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altMiddlename",
              name: "altMiddlename",
              modelValue: _ctx.form.altMiddlename,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.altMiddlename) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_58
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("span", _hoisted_60, [
            _createVNode(_component_InputText, {
              type: "text",
              id: "altLastname",
              name: "altLastname",
              modelValue: _ctx.form.altLastname,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.altLastname) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue"]),
            _hoisted_61
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("span", _hoisted_63, [
            _createVNode(_component_InputText, {
              type: "email",
              id: "altEmail",
              name: "altEmail",
              modelValue: _ctx.form.altEmail,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.altEmail) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_64
          ])
        ]),
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("span", _hoisted_66, [
            _createVNode(_component_InputText, {
              type: "tel",
              id: "altMobile",
              name: "altMobile",
              modelValue: _ctx.form.altMobile,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.altMobile) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_67
          ])
        ])
      ]),
      _createElementVNode("p", _hoisted_68, [
        _createVNode(_component_BaseCheckBox, {
          checkbox: _ctx.terms,
          "onUpdate:checkbox": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.terms) = $event)),
          inputType: _ctx.termsProp
        }, null, 8, ["checkbox", "inputType"]),
        _createElementVNode("span", {
          class: "text-primary text-decoration-underline",
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.termsModal = true))
        }, "Terms and Condition")
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createVNode(_component_BaseButton, {
          disabled: _ctx.loading,
          class: _normalizeClass({ submitting: _ctx.loading }),
          customStyle: _ctx.btnStyle
        }, {
          default: _withCtx(() => [
            _createTextVNode("Register")
          ]),
          _: 1
        }, 8, ["disabled", "class", "customStyle"])
      ])
    ], 544),
    _createVNode(_component_Dialog, {
      visible: _ctx.termsModal,
      "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.termsModal) = $event)),
      style: { width: '50rem' },
      breakpoints: { '600px': '85vw' },
      modal: true,
      header: " ",
      class: "hide_cloe",
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TermsAndConditions)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}